import React from "react";
import { HiOutlineMail } from "react-icons/hi";
import { TbWorld } from "react-icons/tb";
import img from "../../../assets/Donate-part-voluteer/partner.png";
import Title from "../../../Shared/Title/Title";

const PartnerWithUs = () => {
   return (
     <section className="max-w-screen-xl mx-auto lg:my-16 md:my-10 my-5 px-2">
       <h4 className="md:text-4xl text-2xl text-center font-serif font-semibold mb-3 uppercase">
         <Title title={"Partner with us"} />
       </h4>
       <p className="font-semibold text-xl mb-3 italic mt-3 text-center">
         "Coming together is a beginning, Staying together is progress, and
         Working together is Success"
       </p>
       <div className="grid md:grid-cols-2 gap-10 place-content-center">
         <div className="md:w-[90%] mx-auto grid place-content-center mt-5">
           <img
             loading="lazy"
             src={img}
             alt=""
             className="rounded-lg w-full bg-cover"
           />
         </div>
         <div className="grid place-content-center md:w-[90%] leading-3 ">
           <p className=" text-xl font-serif w-[90%]">
             Integrity, Action never work alone; we always look for a
             possibility to work in partnership. We are keen to initiate
             partnerships with organisations that share our ambition.
           </p>
           <div className="mt-4">
             <h4 className="inline-flex text-xl font-semibold">
               <HiOutlineMail size={30} className="mr-2" />
               <a href="mailto:thechange2k19@gmail.com">
                 thechange2k19@gmail.com
               </a>
             </h4>{" "}
             <br />
             <h4 className="inline-flex text-xl font-semibold">
               <TbWorld size={30} className="mr-2" />
               https://www.the-change.com
             </h4>
           </div>
         </div>
       </div>
     </section>
   );
};

export default PartnerWithUs;
